import { render, staticRenderFns } from "./_base-course-player.vue?vue&type=template&id=20a0eb5f"
import script from "./_base-course-player.vue?vue&type=script&lang=js"
export * from "./_base-course-player.vue?vue&type=script&lang=js"
import style0 from "./_base-course-player.vue?vue&type=style&index=0&id=20a0eb5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports